<template>
    <div class="input like-material"
         :class="{'has-val': value.length, 'error': error}">
        <input :type="type" :value="value" @input="change($event)">
        <label><slot></slot></label>
        <div class="err-hint" v-if="error">{{error}}</div>
    </div>
</template>

<script>
    export default {
        props: ['value', 'type', 'label', 'error', 'tabIndex'],
        data(){
            return {

            }
        },
        methods:{
            change(e){
                this.$emit('input', e.target.value)
            }
        }
    }
</script>
